/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'

import ReactHtmlParser from 'react-html-parser'

import {viewData} from '../sell-list/core/_requests'
export function View() {
  const {id} = useParams()

  const [sell, setSell] = useState<any>([])

  useEffect(() => {
    viewData(id).then((res: any) => {
      setSell(res.data[0])
    })
  }, [])
  var editsubsob = '/seller-request/edit/' + id
  
  //remove client

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Seller Product Details</h3>
          </div>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Seller Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'> {sell?.user?.name}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Category</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{sell?.buysell_category?.name} </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Product</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'> {sell?.ProductMaster?.name} </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Quantity</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'> {sell?.qty}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Price</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {sell?.price_per_unit} / {sell?.measurement?.name}
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Area</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{sell?.pincode?.region}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Description</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{sell?.about_product}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Status</label>
            <div className='col-lg-8'>
              <span className={`fw-bolder fs-6   status-${sell?.status}`}>{sell?.status}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Images</label>
            <div className='col-lg-8'>
              {sell?.productImage?.map((item: any, i: any) => {
                return (
                  <img
                    src={item?.image}
                    width='100px'
                    height='100px'
                    style={{marginRight: '10px'}}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
